<template>
  <div>
    
    <el-dialog :title="dialogTitle" :visible="dialogVisible" :close-on-click-modal="false" @close="closeDialog" width="30%">
      <el-form ref="feeForm" label-width="120px" :model="feeForm" :rules="feeRules">
        <el-form-item label="销售资金池" prop="poolCode" required>
          <el-select :disabled="dialogType === 'edit'" v-model="feeForm.poolCode" placeholder="请选择录入到的资金池" style="width: 360px" clearable>
            <el-option v-for="(item, i) in fundPoolList" :key="i" :label='`${item.poolName}(${item.userName})`' :value="item.poolCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期" prop="rq" required>
          <el-date-picker v-model="feeForm.rq" value-format="yyyy-MM-dd" type="date" style="width: 360px" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="费用类型" prop="variousCostCode" required>
          <el-select v-model="feeForm.variousCostCode" placeholder="请选择费用类型" style="width: 360px" clearable>
            <el-option label="运输费" value="vc001"></el-option>
            <el-option label="办公费" value="vc002"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用金额(元)" prop="variousCostFee" required>
          <el-input v-model="feeForm.variousCostFee" type="number" placeholder="请输入费用" style="width: 360px"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="feeForm.remarks" type="textarea" placeholder="请输入备注" :rows="5" style="width: 360px"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="feeSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-form :inline="true">
          <el-form-item label="资金池" style="margin-right: 20px">
            <el-select v-model="queryForm.poolCode" filterable placeholder="请选择资金池" @change="onSearch" clearable>
              <el-option v-for="(item, i) in fundPoolList" :key="i" :label="`${item.poolName}(${item.userName})`" :value="item.poolCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="费用类型" style="margin-right: 20px">
            <el-select v-model="queryForm.variousCostCode" @change="onSearch" placeholder="请选择费用类型" clearable>
              <el-option label="运输费" value="vc001"></el-option>
              <el-option label="办公费" value="vc002"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="导入批次" style="margin-right: 20px">
            <el-input v-model="queryForm.pici" placeholder="请输入导入批次" clearable @clear="onSearch"></el-input>
          </el-form-item>

          <el-button type="primary" icon="el-icon-search" @click="onSearch" size="small">搜索</el-button>

          <!-- <el-form-item label="日期">
            <el-date-picker
              v-model="queryForm.rq"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item> -->
        </el-form>
      </div>
      <!-- 右边工具 -->
      <div>
        <el-button type="success" @click="downloadExcel" size="small">
          <i class="fa fa-level-down" aria-hidden="true"></i>
          导出数据</el-button
        >
        <el-button type="primary" icon="el-icon-edit-outline" @click="batchRecheck" size="small">批量复核</el-button>
      </div>
    </div>

    <!-- 表格 -->
    <div style="margin-top: 10px">
      <el-table class="el-table" :data="tableData" height="calc(100vh - 250px)" stripe border :row-style="{ height: '58px' }"
        :cell-class-name="cellClassName"
        :cell-style="{ padding: '5px 0' }" size="small" fit @close="dialogVisible = false" v-loading="loading"
        element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column
          type="selection" 
          :selectable="selectable"
          width="55">
        </el-table-column>
        <el-table-column prop="poolCode" label="销售资金池编码" align="center" width="130">
        </el-table-column>
        <el-table-column prop="saleUserName" label="销售人员" align="center" width="90">
          <template slot-scope="scope">
            {{ scope.row.saleUserName || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="variousCostName" label="费用类型" align="center" width="90">
        </el-table-column>
        <el-table-column prop="variousCostFee" label="费用金额(元)" align="center" width="110">
        </el-table-column>
        <el-table-column prop="dealUserName" label="录入人员" align="center" width="90">
        </el-table-column>
        <el-table-column prop="checkUserName" label="复核人员" align="center" width="90">
          <template slot-scope="scope">
            {{ scope.row.isCheck === '1' ? scope.row.checkUserName : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="rq" label="日期" align="center">
        </el-table-column>
        <el-table-column prop="remarks" label="备注" align="center">
        </el-table-column>
        <el-table-column prop="operate" label="操作" width="285" align="center">
          <template slot-scope="scope">
            <template v-if="userId != scope.row.userId">
              <el-button type="primary" size="mini" v-if="scope.row.isCheck !== '1'" @click="reCheck(scope.row.id, 1)">
                复核
              </el-button>
              <el-button type="warning" size="mini" v-else @click="reCheck(scope.row.id, 0)">
                撤销复核
              </el-button>
            </template>
            
            <el-button type="primary" :disabled="kaiguan(scope.row.createTime) || scope.row.isCheck === '1'" size="mini"
              @click="handleEdit(scope.row)">修改</el-button>
            <el-button type="danger" :disabled="kaiguan(scope.row.createTime) || scope.row.isCheck === '1'" size="mini"
              @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div style="display: flex; justify-content: space-between; margin-top: 20px">
      <div>费用总金额: {{ feeTotal }}元</div>

      <el-pagination background @current-change="currentChange" @size-change="sizeChange" :total="total"
        :page-size="queryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="queryForm.page"
        layout="sizes, prev, pager, next, jumper, ->, total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import { getFundPoolList, getVariousList, addVarious, deleteVarious, editVarious, checkVarious, batCheckVarious } from '@/api/proj';
import { kz90 } from "../../utils/MyFunction";
export default {
  name: "ProjCost",
  data() {
    return {
      multipleSelection: [], // 选择的多条数据
      uploadVisible: false,
      dialogTitle: '',
      dialogType: '',
      loading: false,
      total: 0, //页面总条数
      tableData: [],
      dialogVisible: false,
      feeForm: {},
      feeRules: {
        poolCode: [
          { required: true, message: '请选择录入的资金池' }
        ],
        rq: [
          { required: true, message: '请选择日期' }
        ],
        variousCostCode: [
          { required: true, message: '请选择费用类型' }
        ],
        variousCostFee: [
          { required: true, message: '请输入费用' }
        ],
      },
      userId: sessionStorage.getItem('uid'),
      fundPoolList: [], // 资金池列表
      queryForm: {
        page: 1,
        limit: 50,
        poolCode: null,
        variousCostCode: null,
      }
    };
  },
  created() {
    this.getFundPoolList();
    this.getVariousList();
  },
  mounted() {

  },
  computed: {
    feeTotal() {
      let total = 0;
      this.tableData.forEach(item => {
        total += Number(item.variousCostFee);
      });
      return total.toFixed(2);
    }
  },
  methods: {
    selectable(row, index) {
      // 根据条件禁用复选框
      return row.isCheck !== '1';
    },
    // 表格单元格样式
    cellClassName({ row, column }) {
        // if (column.type === 'selection' && row.isCheck === '1') {
        //   return 'hidden-row'
        // }
        return ''
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    // 批量复核
    batchRecheck(){
      if(this.multipleSelection.length === 0){
        this.$message({
          type: 'warning',
          message: '请选择需要复核的费用记录'
        });
        return;
      }
      this.$confirm('是否进行批量复核', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = [];
        ids = this.multipleSelection.map(row => {
          return row.id;
        })

        batCheckVarious({ ids, isCheck: "1"}).then(res => {
          if (res.code === 200) {
            this.getVariousList();
            this.$message({
              type: 'success',
              message: '批量复核成功',
            })
          }
        })
      })
    },
    // 是否需要操作
    needOperate(row){
      return !(row.variousCostCode === "vc001" && row.remarks.includes('运输快递费(系统自动入库)'))  // 系统自动录入的运输快递费用不必复核
      && !(row.variousCostCode === "vc002" && row.remarks.includes('办公打印费(系统自动入库)')) // 系统自动录入的办公打印费用不必复核
    },
    // 关闭弹窗
    closeDialog() {
      this.feeForm = {};
      this.$refs.feeForm.resetFields();
      this.dialogVisible = false;
    },
    // 复核操作
    reCheck(id, isCheck) {
      let tipText = (isCheck === 1 ? '是否复核此条录入信息?': '是否撤销复核?')
      this.$confirm(tipText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        checkVarious({ id, isCheck}).then(res => {
          if (res.code === 200) {
            if(isCheck === 1){
              this.$message({
                type: 'success',
                message: '复核成功',
              })
            }else if(isCheck === 0){
              this.$message({
                type: 'success',
                message: '撤销复核成功',
              })
            }
            
            this.getVariousList();
          }
        })
      })
    },
    handleAdd() {
      this.dialogTitle = "添加费用记录";
      this.dialogType = 'add';
      this.dialogVisible = true;
    },
    kaiguan(sj) {
      var sf = kz90(sj);
      return sf;
    },
    // 处理修改事件
    handleEdit(row) {
      this.dialogTitle = "修改费用记录";
      this.dialogType = 'edit';
      this.feeForm = { ...row };
      this.dialogVisible = true;
    },
    // 处理删除事件
    handleDelete(id) {
      this.$confirm('确定删除这条费用信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteVarious({ id }).then(res => {
          if (res.code === 200) {
            this.getVariousList();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        })
      })
    },
    currentChange(e) {
      this.queryForm.page = e;
      this.getVariousList();
    },
    sizeChange(e) {
      this.queryForm.page = 1;
      this.queryForm.limit = e;
      this.getVariousList();
    },
    // 搜索中
    onSearch() {
      this.queryForm.page = 1;
      this.getVariousList();
    },
    // ==================== 导出 Excel（exceljs，数据驱动，不读 DOM） ====================
    // 文件名用的日期后缀：YYYYMMDD
    exportFileDate() {
      const d = new Date();
      const p = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}`;
    },
    // 列表查询与导出共用同一套筛选参数，避免两处拼参不一致
    buildVariousQuery(page, limit) {
      let form = {
        page: page,
        limit: limit,
        pici: this.queryForm.pici
      }
      if (this.queryForm.poolCode) form.poolCode = this.queryForm.poolCode;
      if (this.queryForm.variousCostCode) form.variousCostCode = this.queryForm.variousCostCode;
      return form;
    },
    // 导出列定义：页面表格列去掉选择列与"操作"列
    getExportColumns() {
      return [
        { header: "销售资金池编码", key: "poolCode", width: 18 },
        { header: "销售人员", key: "saleUserName", width: 12 },
        { header: "费用类型", key: "variousCostName", width: 16 },
        { header: "费用金额(元)", key: "variousCostFee", width: 15, money: true },
        { header: "录入人员", key: "dealUserName", width: 12 },
        {
          header: "复核人员",
          key: "checkUserName",
          width: 12,
          // 与页面一致：未复核不显示复核人；这里不写 "--" 占位符
          format: (row) => (String(row.isCheck) === "1" ? row.checkUserName : ""),
        },
        { header: "日期", key: "rq", width: 14 },
        { header: "备注", key: "remarks", width: 36, align: "left" },
      ];
    },
    // 用数据数组生成 Excel（exceljs 体积较大，动态导入，仅在点击导出时加载）
    // rows      - 要导出的数据数组
    // fileName  - 文件名，如 "销售资金池费用复核_20260212.xlsx"
    // sheetName - 工作表名，默认取文件名去掉扩展名
    async exportRowsToExcel(rows, fileName, sheetName) {
      const mod = await import(/* webpackChunkName: "exceljs" */ "exceljs");
      // 兼容 CJS 模块被 webpack 包装成 { default: ... } 的情况
      const ExcelJS =
        mod && mod.Workbook ? mod : mod && mod.default ? mod.default : mod;
      const columns = this.getExportColumns();

      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet(
        sheetName || String(fileName || "Sheet1").replace(/\.xlsx$/i, "")
      );

      // 列定义（表头行由 columns.header 自动生成）
      sheet.columns = columns.map((col, i) => ({
        header: col.header,
        key: "c" + i,
        width: col.width,
      }));

      const thin = { style: "thin", color: { argb: "FFD0D0D0" } };

      // 表头样式：加粗 + 灰底 + 居中 + 边框
      const headerRow = sheet.getRow(1);
      headerRow.height = 22;
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, size: 11, color: { argb: "FF515A6E" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFEEF1F6" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = { top: thin, left: thin, bottom: thin, right: thin };
      });

      // 冻结首行：滚动时表头常驻
      sheet.views = [{ state: "frozen", ySplit: 1 }];

      // 数据行
      (rows || []).forEach((row) => {
        const values = columns.map((col) => {
          const raw = col.format ? col.format(row) : row[col.key];
          // 空值写成真正的空单元格，不写 "--"，避免影响 Excel 求和
          if (raw === null || raw === undefined || raw === "") return null;
          if (col.money) {
            const n = Number(raw);
            return isNaN(n) ? null : n;
          }
          return raw;
        });
        const added = sheet.addRow(values);

        columns.forEach((col, i) => {
          const cell = added.getCell(i + 1);
          cell.border = {
            top: { style: "thin", color: { argb: "FFE8E8E8" } },
            left: { style: "thin", color: { argb: "FFE8E8E8" } },
            bottom: { style: "thin", color: { argb: "FFE8E8E8" } },
            right: { style: "thin", color: { argb: "FFE8E8E8" } },
          };
          if (col.money) {
            // 千分位 + 两位小数；保留数值类型，可在 Excel 中继续排序/求和
            cell.numFmt = "#,##0.00";
            cell.alignment = { horizontal: "right", vertical: "middle" };
          } else {
            cell.alignment = {
              horizontal: col.align || "center",
              vertical: "middle",
            };
          }
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      FileSaver.saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        fileName
      );
    },
    // 导出入口：按当前筛选条件拉全量数据后直接生成 Excel（不渲染表格，无需还原分页状态）
    downloadExcel() {
      const EXPORT_LIMIT = 99999; // 用超大 limit 让服务端返回"筛选后的全部记录"
      const fileName = "销售资金池费用复核_" + this.exportFileDate() + ".xlsx";
      this.loading = true;
      getVariousList(this.buildVariousQuery(1, EXPORT_LIMIT))
        .then((res) => {
          this.loading = false;
          const rows = (res && res.data) || [];
          if (!rows.length) {
            this.$message({
              type: "warning",
              message: "当前筛选条件下没有数据",
            });
            return;
          }
          return this.exportRowsToExcel(rows, fileName).catch((e) => {
            console.log(e);
            this.$message({ type: "error", message: "导出失败，请重试" });
          });
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
        });
    },
    getFundPoolList() {
      getFundPoolList({
        page: 1,
        limit: 1000
      }).then(res => {
        if (res.code === 200) {
          this.fundPoolList = res.data
        }
      })
    },
    getVariousList() {
      this.loading = true;
      getVariousList(this.buildVariousQuery(this.queryForm.page, this.queryForm.limit)).then(res => {
        if (res.code === 200) {
          this.total = res.count;
          this.tableData = res.data;
          this.loading = false;
        }
      })
    },
    feeSubmit() {
      this.$refs.feeForm.validate((valid) => {
        if (valid) {
          if (this.dialogType === 'add') {
            addVarious(this.feeForm).then(res => {
              if (res.code === 200) {
                this.queryForm.page = 1;
                this.queryForm.poolCode = '';
                this.queryForm.variousCostCode = '';
                this.$message({
                  type: 'success',
                  message: '添加成功'
                })
                this.getVariousList();
                this.dialogVisible = false;
              }
            })
          } else if (this.dialogType === 'edit') {
            editVarious(this.feeForm).then(res => {
              if (res.code === 200) {
                this.$message({
                  type: 'success',
                  message: '修改成功'
                })
                this.getVariousList();
                this.dialogVisible = false;
              }
            })
          }
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.el-table {
  ::v-deep .hidden-row .cell {
    display: none;
  }
}
</style>
